import { CreateOrderParams } from '@features/order/services/order-api/order-api.service';
import { createAction, props } from '@ngrx/store';
import { MFAOutcome } from '@rd/core/mfa/types';
import { HttpError } from '@rd/types';
import { Order } from '@rd/types/order.type';

export enum CreateOrderActionTypes {
  CREATE_ORDER_CHECKOUT = '[OrderCheckout] Create Order Checkout',
  CREATE_ORDER_CHECKOUT_SUCCESS = '[OrderCheckout] Create Order Checkout Success',
  CREATE_ORDER_CHECKOUT_FAIL = '[OrderCheckout] Create Order Checkout Fail',
  HYDRATE_ORDER = '[OrderCheckout] Hydrate Order Checkout',
}

export const CreateOrder = createAction(
  CreateOrderActionTypes.CREATE_ORDER_CHECKOUT,
  props<{ createOrderParams?: CreateOrderParams }>(),
);

export const CreateOrderSuccess = createAction(
  CreateOrderActionTypes.CREATE_ORDER_CHECKOUT_SUCCESS,
  props<{ order: Order }>(),
);

export const CreateOrderFail = createAction(
  CreateOrderActionTypes.CREATE_ORDER_CHECKOUT_FAIL,
  props<HttpError>(),
);

export const HydrateOrder = createAction(
  CreateOrderActionTypes.HYDRATE_ORDER,
  props<{ order: Order; outcome: MFAOutcome }>(),
);
